import classNames from "classnames";
import Image from "next/image";
import "./styles.scss";
import { TitleProps } from "./types";

export const Title: React.FC<TitleProps> = ({
  hero,
  regular,
  medium,
  grand,
  icon,
  className,
  tag = "div", // Default to div if not provided
  content,
  dataQa,
  iconAlt = "icon", // Default alt text
  iconWidth = 24, // Default width for the icon
  iconHeight = 24, // Default height for the icon
}) => {
  const classnames = classNames("title", {
    "title--hero": hero,
    "title--regular": regular,
    "title--medium": medium,
    "title--grand": grand,
    "title--icon": !!icon,
    [className || ""]: className, // Add className if present
  });

  const img = icon ? (
    <Image
      src={icon}
      alt={iconAlt}
      width={iconWidth}
      height={iconHeight}
    />
  ) : null;

  const Tag = tag as keyof JSX.IntrinsicElements;

  return (
    <Tag
      data-testid="title"
      className={classnames}
      data-qa={dataQa}>
      {img}
      {content}
    </Tag>
  );
};
